import { createAppSlice } from '../app.slice';

const initialState = {
  attributes: null,
  isLoading: false,
};

const setUserAttribute = ({ state, id, value }) => {
  let updatedState = null;

  if (id === 'OTP_DELIVERY_METHOD')
    updatedState = {
      ...state,
      attributes: { ...state.attributes, OTPDeliveryMethod: value },
    };

  updatedState.isLoading = false;

  return updatedState;
};

export const userAttributesSlice = createAppSlice({
  name: 'userAttributesSlice',
  initialState,
  reducers: {
    getUserAttributesRequest: (state) => {
      state.isLoading = true;
    },
    getUserAttributesFailure: (state) => {
      state.isLoading = false;
    },
    setUserAttributeRequest: (state) => {
      state.isLoading = true;
    },
    setUserAttributeFailure: (state) => {
      state.isLoading = false;
    },
    saveUserAttribute: (state, action) => {
      const { id, value } = action.payload;

      const updatedState = setUserAttribute({ state, id, value });

      return updatedState;
    },
  },
});
